/**
* @name: user-drop-down-sca
* @author: weiyong
* @date: 2023-05-12 10:14
* @description：user-drop-down-sca
* @update: 2023-05-12 10:14
*/
<template>
  <a-dropdown>
    <div class="user-drop-down-sca" @click.prevent>
      <div class="flex-div content-bar" :style="{padding: isFrameType ? '0 8px 0 12px' : '0'}">
        <span class="user-icon" v-if="!isFrameType">
          <i class="remix-icon ri-account-pin-circle-line"></i>
        </span>
        <span :style="isFrameType ? getTechnologyFrameTextColor : ''" :class="isFrameType ? 'label-span-text' : 'label-span'">  {{ getUserInfo.realName || getUserInfo.userName }}</span>
        <span :style="isFrameType ? getTechnologyFrameTextColor : ''" :class="['remix-icon', 'ri-arrow-down-s-line', isFrameType ? 'remix-icon-text' : '']"> </span>
      </div>
    </div>

    <template #overlay>
      <a-menu @click="handleMenuClick" class="user-drop-down-sca">

        <drop-menu-item
          key="userInfo"
          :text="t('用户信息')"
          :svgIconFlag="false"
          :user-icon-flag="true"
          userIcon="remix-icon  ri-ren"
        />

        <drop-menu-item
          key="modPwd"
          :text="t('layout.header.修改密码')"
          :svgIconFlag="true"
          icon="modPwd"
        />
<!--        锁屏-->
        <drop-menu-item
          key="lock"
          :text="t('layout.header.tooltipLock')"
          icon="ion:lock-closed-outline"
        />

<!--        退出系统-->
        <drop-menu-item
          key="logout"
          :text="t('layout.header.dropdownItemLoginOut')"
          icon="ion:power-outline"
        />

<!--        租户切换-->
        <!-- <SwitchTenant ref="tenantRef"/> -->

      </a-menu>
    </template>
  </a-dropdown>

  <lock-modal @register="register"/>

  <Modal
    class="no-bottom-bar BasicModal"
    v-model:visible="modPwdFlag"
    :footer="false"
    :ok-button-props="{ display: 'none' }"
    :cancel-button-props="{ display: 'none' }"
    :title="t('component.password.密码修改')"
    width="650"
  >
    <ChangePassword style="padding: 10px 55px"/>
  </Modal>

</template>

<script lang="ts" setup>
import LockModal from "@/layouts/default/header/components/lock/LockModal.vue";
import SwitchTenant from '@/layouts/default/header/components/user-dropdown/switch-tenant.vue'
import DropMenuItem from "@/layouts/default/header/components/user-dropdown/DropMenuItem.vue";
import {DownOutlined} from "@ant-design/icons-vue";
import {Dropdown as ADropdown,Menu as AMenu,MenuItem as AMenuItem,Modal} from "ant-design-vue";
import ChangePassword from '@/systemPage/password/index.vue';
import {useDesign} from "@/hooks/web/useDesign";
import { useI18n } from 'vue-i18n';
import {userUserDropHook} from "@/layouts/default/header/components/hooks/userUserDropHook";
import {useHeaderSetting} from "@/hooks/setting/useHeaderSetting";
import {useUserStore} from "@/store/modules/user";
import {useRouter} from "vue-router";
import {useModal} from "@/components/Modal";
import {computed, ref} from "vue";
import { useAppFrame } from '@/hooks/useAppFrame';

const {prefixCls} = useDesign('user-drop-down-sca');
const { isFrameType,getTechnologyFrameTextColor } = useAppFrame();
defineOptions({
  components: {},
  name: "user-drop-down-sca",
})

const { t } = useI18n();
const {getShowDoc, getUseLockPage} = useHeaderSetting();
const userStore = useUserStore();
const router = useRouter();
const [register, {openModal}] = useModal();
// const tenantRef = ref<InstanceType<typeof SwitchTenant>>(null);

const getUserInfo = computed(() => {
  const {
    realName = '',
    avatar,
    desc,
    userName,
  } = userStore.userInfo || userStore.getUserInfo || {};
  return {realName, avatar: avatar, desc, userName};
});

const {modPwdFlag, portalSettingFlag, handleMenuClick} = userUserDropHook({
  userStore,
  router,
  openModal,
  // tenantRef
});
</script>

<style type="text/css" lang="less">
.user-drop-down-sca{
  cursor: pointer;
  .content-bar{
    height: 100%;align-items: center;
    display: flex;
  }
  .user-icon{
    display: inline-block;
    padding: 0 4px;
  }
  .label-span,.label-span-text{
    font-size: var(--el-font-size-base);
    display: inline-flex;
    position: relative;
    color:var(--el-text-color-primary,#0a001f);
  }
  .remix-icon,.remix-icon-text{
    display: inline-block;
    padding: 0 4px;
    padding-right: 0;
    color:var(--el-text-color-primary,#0a001f);
  }

  .label-span-text{
    font-size: 14px;
    // color: #FFF;
  }
  .remix-icon-text{
    color: #FFF;
    padding: 0;
  }

}
</style>
